import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Logout`, method: 'GET'})
}
